"use client";

import { CustomerServiceFormSubmitEvent, track } from "@homeinstead/analytics";
import { EventName } from "@homeinstead/shared";

type CustomerServiceFormSubmissionResult =
  | "exception-error"
  | "server-error"
  | "success"
  | "validation-error";

function trackCustomerServiceFormSubmit(
  result: CustomerServiceFormSubmissionResult,
  franchiseNumber: string,
): void {
  track(
    EventName.CUSTOMER_SERVICE_FORM_SUBMIT,
    CustomerServiceFormSubmitEvent({
      franchiseNumber,
      result,
    }),
  );
}

export { trackCustomerServiceFormSubmit };
